import { Reveal, SectionHeading } from "./Reveal";
import { STATS } from "@/data/content";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-44">
      <div className="max-w-[88rem] mx-auto px-6 md:px-10">
        <SectionHeading chapter="01" overline="About Me" title="Creative Editor. Visual Storyteller." />

        <div className="grid lg:grid-cols-[1fr_1.15fr] gap-12 lg:gap-20 items-start">
          <div className="order-2 lg:order-1">
            <Reveal>
              <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
                I turn ideas into cinematic visuals, engaging reels, powerful graphics and
                AI-powered creative experiences.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-base md:text-lg text-zinc-400 leading-relaxed">
                From concept to final frame, every project is crafted with creativity,
                precision and a cinematic eye.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 border-l-2 border-gold/60 pl-6" data-testid="about-signature">
                <p className="font-display italic text-2xl md:text-3xl text-gold">— Inder</p>
                <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">
                  Creative Director & Visual Creator
                </p>
              </div>
            </Reveal>

            <div className="mt-12 grid grid-cols-2 gap-4 md:gap-6" data-testid="stats-grid">
              {STATS.map((s, i) => (
                <Reveal key={s.label} delay={0.08 * i}>
                  <div
                    data-testid={`stat-card-${i}`}
                    className="group rounded-2xl border border-white/[0.08] bg-surface p-6 md:p-8 hover:border-gold/40 transition-colors duration-500"
                  >
                    <span className="block h-1.5 w-8 rounded-full bg-gold/70 group-hover:w-12 transition-[width] duration-500" />
                    <p className="mt-4 font-display text-xl md:text-2xl font-semibold text-gold leading-snug">{s.label}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.15} className="order-1 lg:order-2 lg:sticky lg:top-28">
            <div className="relative">
              <div className="absolute -inset-8 glow-gold blur-[100px] opacity-70" />
              <div className="relative overflow-hidden rounded-3xl border border-gold/25 shadow-[0_0_50px_rgba(229,169,60,0.12)]">
                <img
                  src="/assets/portrait.png"
                  alt="Portrait of Inder, founder of MARKMAXO, in his editing studio"
                  className="w-full aspect-[4/5] object-cover object-[center_top] hover:scale-105 transition-transform duration-[1.2s] ease-out"
                  data-testid="about-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-void/80 via-transparent to-transparent" />
                <p className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-[0.25em] text-zinc-300">
                  Inder — Creative Director & Visual Creator
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
